<template>
	<div class="guide-item-condensed">
		<div class="guide-item-condensed__content">
			<PictureComp
				v-if="articleImage"
				class="guide-item-condensed__content__image"
				imageProfile="backdrop"
				:imageUrl="articleImage"
				:alt="altText"
			/>
			<h3 class="guide-item-condensed__content__title">{{ articleTitle }}</h3>
			<FontAwesomeIcon :icon="faArrowRight" class="guide-item-condensed__content__arrow" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { ArticleFragment } from '@/features/editorial/graphql/fragments/Article.fragment';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const props = defineProps<{ article: ArticleFragment; index: number }>();

const mainImageEntityBackdrop = computed(() => {
	return props.article?.content?.mainImageEntityBackdrop?.backdropUrl
		? props.article?.content?.mainImageEntityBackdrop?.backdropUrl
		: '';
});

const trimH1Tags = (string: string) => {
	return string.substring(4, string.length - 5);
};

const articleTitle = computed(() => {
	return trimH1Tags(props.article.content.title || '');
});

const altText = computed(() => {
	return props.article?.content?.headerImage?.altText ?? articleTitle.value;
});

const headerImageURL = computed(() => {
	return props.article?.content?.headerImage?.url ?? '';
});

const articleImage = computed(() => {
	if (!!headerImageURL.value) return headerImageURL.value;

	const backdropIndex = props.article.mainObjects[0].node.content.backdrops[props.index] ? props.index : 0;
	return !!mainImageEntityBackdrop.value
		? `https://www.justwatch.com/images${mainImageEntityBackdrop.value}`
		: props.article.mainObjects[0].node.content.backdrops[backdropIndex].backdropUrl;
});
</script>

<style lang="scss" scoped>
.guide-item-condensed {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	max-height: 100%;
	padding: 8px 16px;

	&__content {
		display: flex;
		align-items: center;
		max-height: 32px;
		width: 100%;

		&__image {
			object-fit: contain;
			max-height: 32px;
			width: auto;
			margin-inline-end: 16px;

			@media (max-width: 700px) {
				margin-inline-end: 8px;
			}

			:deep(img) {
				object-fit: cover;
				max-height: 32px;
				width: auto;
				border-radius: 4px;
			}
		}

		&__title {
			font-size: 16px;
			font-weight: 400;
			letter-spacing: 0.24px;
			color: #b8b8b8;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			width: 100%;
			margin-inline-end: 16px;

			@media (max-width: 700px) {
				margin-inline-end: 8px;
			}
		}

		&__arrow {
			color: #d5d5d5;
			margin-inline-start: auto;
		}
	}
}
</style>
